import httpClient from './httpClient';

const conceptosNoAfectanVacacionesService = {
  obtenerConceptos: async (empresaId) => {
    try {
      const response = await httpClient.get(`/conceptos-no-afectan-vacaciones/empresa/${empresaId}`);
      return {
        success: true,
        data: response.data.data || response.data,
        message: response.data.message,
      };
    } catch (error) {
      console.error('Error al obtener conceptos que no afectan vacaciones:', error);
      return {
        success: false,
        error: error.response?.data?.message || 'Error al obtener la configuración',
        data: [],
      };
    }
  },

  obtenerConceptosIngresosDisponibles: async () => {
    try {
      const response = await httpClient.get('/conceptos-no-afectan-vacaciones/conceptos-ingresos');
      return {
        success: true,
        data: response.data.data || response.data,
        message: response.data.message,
      };
    } catch (error) {
      console.error('Error al obtener conceptos de ingresos:', error);
      return {
        success: false,
        error: error.response?.data?.message || 'Error al obtener conceptos de ingresos',
        data: [],
      };
    }
  },

  configurar: async (empresaId, conceptosIds) => {
    try {
      const response = await httpClient.post('/conceptos-no-afectan-vacaciones/configurar', {
        empresa_id: empresaId,
        conceptos_plame_ids: conceptosIds,
      });
      return {
        success: true,
        data: response.data.data || response.data,
        message: response.data.message || 'Configuración guardada exitosamente',
      };
    } catch (error) {
      console.error('Error al configurar conceptos que no afectan vacaciones:', error);
      return {
        success: false,
        error: error.response?.data?.message || 'Error al guardar configuración',
        errors: error.response?.data?.errors,
      };
    }
  },

  agregarConcepto: async (empresaId, conceptoPlameId) => {
    try {
      const response = await httpClient.post('/conceptos-no-afectan-vacaciones', {
        id_empresa: empresaId,
        id_concepto_plame: conceptoPlameId,
      });
      return {
        success: true,
        data: response.data.data || response.data,
        message: response.data.message || 'Concepto agregado exitosamente',
      };
    } catch (error) {
      console.error('Error al agregar concepto:', error);
      return {
        success: false,
        error: error.response?.data?.message || 'Error al agregar concepto',
        errors: error.response?.data?.errors,
      };
    }
  },

  removerConcepto: async (empresaId, conceptoPlameId) => {
    try {
      const response = await httpClient.delete(
        `/conceptos-no-afectan-vacaciones/empresa/${empresaId}/concepto/${conceptoPlameId}`
      );
      return {
        success: true,
        message: response.data.message || 'Concepto removido exitosamente',
      };
    } catch (error) {
      console.error('Error al remover concepto:', error);
      return {
        success: false,
        error: error.response?.data?.message || 'Error al remover concepto',
      };
    }
  },

  verificar: async (empresaId, conceptoPlameId) => {
    try {
      const response = await httpClient.get(
        `/conceptos-no-afectan-vacaciones/verificar/${empresaId}/${conceptoPlameId}`
      );
      return {
        success: true,
        data: response.data.data || response.data,
        noAfectaVacaciones: response.data.data?.no_afecta_vacaciones || false,
      };
    } catch (error) {
      console.error('Error al verificar concepto:', error);
      return {
        success: false,
        error: error.response?.data?.message || 'Error al verificar concepto',
        noAfectaVacaciones: false,
      };
    }
  },
};

export default conceptosNoAfectanVacacionesService;
